import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisJobService } from '../../service/his-job.service';
import { HisJobStatus } from '../../model/his-job-status';
import { HisJobProtocolChunk } from '../../model/his-job-protocol-chunk';
import { HisJobProtocolLine } from '../../model/his-job-protocol-line';
import { TablePageEvent, Table } from 'primeng/table';

@Component( {
    selector: 'his-job-details',
    templateUrl: './his-job-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisJobDetailsComponent {
    private jobService = inject(HisJobService);

    @Input() jobDetailsVisible = false;

    internalJobStatus: HisJobStatus;
    protected math = Math;
    protected currentPage = 1;

    @Input(  )
    set jobStatus( value: HisJobStatus ) {
        this.internalJobStatus = value;
        this.refreshJobProtocol();
    }
    get jobStatus(): HisJobStatus {
        return this.internalJobStatus;
    }

    loggingLines: HisJobProtocolLine[] = [];
    lastProtocolChunk: HisJobProtocolChunk;
    protected rowsPerPage = 10;

    refreshJobProtocol() {
        if ( !this.jobStatus || !this.jobDetailsVisible ) {
            return;
        }

        let startPos = 0;
        let maxLines = 100;
        if ( this.chunkFitsStatus( this.lastProtocolChunk ) ) {
            startPos = this.lastProtocolChunk.endPos;
        }

        this.jobService.getJobProtocol( this.jobStatus.handle, startPos, maxLines ).subscribe(
            ( chunk: HisJobProtocolChunk ) => {
                if ( !this.chunkFitsStatus( chunk ) ) {
                    this.loggingLines = [];
                    return; // Mittlerweile wird ein neuer Job angezeigt
                }

                if ( chunk.startPos === 0 || !this.chunkFitsStatus( this.lastProtocolChunk ) ) {
                    this.loggingLines = [];
                }

                if ( chunk.lines ) {
                    this.loggingLines = [...this.loggingLines, ...chunk.lines];
                }

                this.lastProtocolChunk = chunk;
            }
        );
    }

    chunkFitsStatus( chunk: HisJobProtocolChunk ): boolean {
        return chunk && ( chunk.handle.executionId === this.jobStatus.handle.executionId );
    }

    showJobDetails() {
        this.jobDetailsVisible = true;
        this.refreshJobProtocol();
    }

    hideJobDetails() {
        this.jobDetailsVisible = false;
    }

    protected onPageChange( event: TablePageEvent ) {
        const rows = this.loggingLines ? Math.ceil( this.loggingLines.length / this.rowsPerPage ) : 0;
        if ( rows === 0 ) return;
        this.currentPage = Math.ceil( ( event.first + 1 ) / this.rowsPerPage );
    }

    protected onRowsPerPageChange( newRowsPerPage: number ) {
        this.rowsPerPage = newRowsPerPage;
        this.currentPage = 1; // Reset to first page when rows per page changes
    }
}
